import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { authAPI } from '../api/api';

function PrivateRoute({ children, adminOnly = false }) {
  const { user, setUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If user is already in context, don't need to check session
    if (user) {
      setLoading(false);
    } else {
      // Only try to check session if no user in context
      // This handles the case where user was logged out
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && user.Role !== 'Admin') {
    return <Navigate to="/dashboard" />;
  }

  return children;
}

export default PrivateRoute;
